export default __webpack_public_path__ + "static/media/Ficha Técnica - Acerola Orgânica.57dbbab2.pdf";